import React from 'react';
import styled, { withTheme } from 'styled-components'

import { IconButton } from '../common';
import { PRODUCT_STATUS } from '../../constants/product';

const Wrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    width: 125px;
`


export const ProductsTableActions = withTheme(({ category, productId, status, onEdit, onDelete, onChangeStatus, theme }) => {

    const handleEditProduct = () => {
        onEdit(productId)
    }

    const handleDeleteProduct = () => {
        onDelete(productId)
    }

    const handleChangeStatus = () => {
        onChangeStatus(productId)
    }



    return (
        <Wrapper>
            {status === PRODUCT_STATUS.ACTIVE
                ? (
                    <IconButton icon={"minus"} onClick={handleChangeStatus} title={`Desativar`} />
                )
                : (
                    <IconButton icon={"plusBlue"} onClick={handleChangeStatus} title={`Ativar`} />
                )
            }
            <IconButton icon={"edit"} onClick={handleEditProduct} title={`Editar`} />
            <IconButton icon={"delete"} onClick={handleDeleteProduct} title={`Excluir`} />
        </Wrapper>
    )
})

